import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const MiniGauge = ({
	value,
	max,
	label,
	unit = "",
	smallHint = "",
	color = "#111",
}) => {
	const size = 48;
	const stroke = 8;
	const radius = (size - stroke) / 2;
	const circumference = 2 * Math.PI * radius;

	const v = Number.isFinite(Number(value)) ? Number(value) : 0;
	const m =
		Number.isFinite(Number(max)) && Number(max) > 0 ? Number(max) : 100;
	const pct = Math.max(0, Math.min(1, v / m));

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				p: 1,
				bgcolor: "white",
				borderRadius: 2,
			}}
		>
			<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					stroke="black"
					strokeWidth={stroke}
					fill="none"
				/>
				<motion.circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					stroke={color}
					strokeWidth={stroke}
					strokeLinecap="round"
					fill="none"
					strokeDasharray={`${pct * circumference} ${circumference}`}
					strokeDashoffset="0"
					initial={{ strokeDasharray: `0 ${circumference}` }}
					animate={{
						strokeDasharray: `${
							pct * circumference
						} ${circumference}`,
					}}
					transition={{ type: "spring", stiffness: 80, damping: 12 }}
					transform="rotate(-90 24 24)"
				/>
				<text
					x="50%"
					y="50%"
					textAnchor="middle"
					dy="6"
					fontSize="10"
					fill="black"
				>
					{Math.round(v)}
					<tspan fontSize="10"> {unit}</tspan>
				</text>
			</svg>

			{/* label can be an icon node; render as-is */}
			<Typography
				variant="caption"
				sx={{ color: "black", display: "grid", placeItems: "center" }}
			>
				{label}
			</Typography>
			{smallHint ? (
				<Typography variant="subtitle2">{smallHint}</Typography>
			) : null}
		</Box>
	);
};

export default MiniGauge;
